export const LAMBDATEST_ABORT_LOADING = "LAMBDATEST_ABORT_LOADING";
export const LAMBDATEST_ABORT_SUCCESS = "LAMBDATEST_ABORT_SUCCESS";
export const LAMBDATEST_ABORT_FAILED = "LAMBDATEST_ABORT_FAILED";
export const LAMBDATEST_ABORT_CLEAR = "LAMBDATEST_ABORT_CLEAR";
